import store from '../store'

export const inviteMethods = {
  computed: {
    defaultInvitationURL() {
      const currentResource = store.getters['resource/currentResource'];

      let defaultInvitationURLPostfix = '#WkModal(plans,{invite_code})';

      if (!currentResource) return defaultInvitationURLPostfix;

      return `${currentResource.host}/${defaultInvitationURLPostfix}`;
    }
  },
  methods: {
    copyDataToClipboard(text, customText=false) {
      const textarea = document.createElement("textarea");

      textarea.textContent = customText ? text : this.inviteCodeFullURL(text);

      textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");  // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
      } finally {
        document.body.removeChild(textarea);
      }
    },
    inviteCodeFullURL(text) {
      let currentResource = store.getters['resource/currentResource'];

      if (!currentResource) return text;

      let {invitation_landing_url} = currentResource;

      if (!invitation_landing_url) invitation_landing_url = this.defaultInvitationURL;

      return invitation_landing_url.replace('{invite_code}', text);
    }
  }
};
